import { application } from './application.js'
import GtmEventsController from './gtm_events_controller'
import LemonwayIframeController from './lemonway_iframe_controller'
import PromoCodeController from './promo_code_controller'
import BreadcrumbController from './signature/breadcrumb_controller'
import ContractController from './signature/contract_controller'
import ProgressController from './signature/progress_controller'
import SignatureController from './signature/signature_controller'
import SubscriptionStepsController from './signature/subscription_steps_controller'
import SubmitConfirmationController from './submit_confirmation_controller'
import SddMandateController from './sdd_mandate_controller'
import TomSelectController from './tom_select_controller.js'
import RedactorController from './redactor_controller.js'
import NestedFormController from './nested_form_controller.js'
import LendingTimetableFormController from './lending_timetable_form_controller.js'
import RoyaltiesTimetableFormController from './royalties_timetable_form_controller.js'

// Register controllers
application.register('gtm-events', GtmEventsController);
application.register('lemonway-iframe', LemonwayIframeController);
application.register('promo-code', PromoCodeController);
application.register('signature-breadcrumb', BreadcrumbController);
application.register('signature-contract', ContractController);
application.register('signature-progress', ProgressController);
application.register('signature', SignatureController);
application.register('signature-subscription-steps', SubscriptionStepsController);
application.register('submit-confirmation', SubmitConfirmationController);
application.register('sdd-mandate', SddMandateController);
application.register('tom-select', TomSelectController);
application.register('redactor', RedactorController);
application.register('nested-form', NestedFormController);
application.register('lending-timetable-form', LendingTimetableFormController);
application.register('royalties-timetable-form', RoyaltiesTimetableFormController);
